import { useLoaderData } from 'react-router-dom';
import { Card, Container, Alert, Link } from '@chakra-ui/react';
import ViewContent from './view-content';
import { Content, ContentTypeFieldView } from '@/lib/types';

export default function PublicContent() {
  const data = useLoaderData() as {
    content: Content;
    subContents: any;
    contentTypeFields: ContentTypeFieldView[];
    workspaceCreatorEmail: string;
    workspaceName: string;
  };

  return (
    <Card.Root minH={'100vh'} mx={'auto'} width={{ md: '90%' }} maxW={'3xl'} className='print-card'>
      <Card.Body>
        {data && (
          <Container maxW={'container.md'}>
            <ViewContent data={data} isPublic={true} />

            {data.workspaceName && data.workspaceCreatorEmail && (
              <Alert.Root status={'info'} borderRadius={'md'}>
                <Alert.Indicator />
                <Alert.Title>
                  This content is managed on {data.workspaceName}. To edit this content or created
                  you own, contact{' '}
                  <Link
                    href={`mailto:${data.workspaceCreatorEmail}`}
                    color={'blue.600'}
                    fontWeight={'bold'}
                    variant='underline'
                  >
                    {data.workspaceCreatorEmail}
                  </Link>{' '}
                  and ask to join their Athlete Era workspace.
                </Alert.Title>
              </Alert.Root>
            )}
          </Container>
        )}
      </Card.Body>
    </Card.Root>
  );
}
